import { useState, useEffect } from 'react';
import ImageUpload from '../ImageUpload';
import { apiGet, apiPut } from '../api';

export default function PromoSection() {
  const [data, setData] = useState({
    title_line1: '',
    subtitle_line1: '',
    subtitle_line2: '',
    subtitle_line3: '',
    subtitle_line4: '',
    instagram_url: '',
    post_image1: '',
    post_image2: '',
    post_image3: '',
    post_url1: '',
    post_url2: '',
    post_url3: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await apiGet('promo.php');
      if (result) {
        setData({
          title_line1: result.title_line1 || '',
          subtitle_line1: result.subtitle_line1 || '',
          subtitle_line2: result.subtitle_line2 || '',
          subtitle_line3: result.subtitle_line3 || '',
          subtitle_line4: result.subtitle_line4 || '',
          instagram_url: result.instagram_url || '',
          post_image1: result.post_image1 || '',
          post_image2: result.post_image2 || '',
          post_image3: result.post_image3 || '',
          post_url1: result.post_url1 || '',
          post_url2: result.post_url2 || '',
          post_url3: result.post_url3 || ''
        });
      }
    } catch (err) {
      setMessage('Erro ao carregar dados');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      const result = await apiPut('promo.php', data);
      setMessage(result.success ? 'Salvo com sucesso!' : 'Erro ao salvar');
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Erro ao salvar dados');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div>Carregando...</div>;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Promoções (Instagram)</h2>

      <div className="space-y-4">
        {/* Title */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3">Título Principal</h3>
          <input
            type="text"
            value={data.title_line1}
            onChange={(e) => setData({ ...data, title_line1: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="SEGUE-ME!"
          />
        </div>

        {/* Subtitle Lines */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-3">Subtítulo (4 linhas)</h3>
          <div className="space-y-2">
            <input
              type="text"
              value={data.subtitle_line1}
              onChange={(e) => setData({ ...data, subtitle_line1: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 1: PROMETO"
            />
            <input
              type="text"
              value={data.subtitle_line2}
              onChange={(e) => setData({ ...data, subtitle_line2: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 2: NÃO DEIXAR"
            />
            <input
              type="text"
              value={data.subtitle_line3}
              onChange={(e) => setData({ ...data, subtitle_line3: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 3: MIGALHAS"
            />
            <input
              type="text"
              value={data.subtitle_line4}
              onChange={(e) => setData({ ...data, subtitle_line4: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
              placeholder="Linha 4: NO TEU FEED."
            />
          </div>
        </div>

        {/* Instagram URL */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL do perfil Instagram
          </label>
          <input
            type="url"
            value={data.instagram_url}
            onChange={(e) => setData({ ...data, instagram_url: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
            placeholder="https://www.instagram.com/bolacha.mulata/"
          />
        </div>

        {/* Publications */}
        <div className="bg-gray-50 p-4 rounded-lg space-y-6">
          <div>
            <h3 className="font-semibold text-gray-800 mb-1">Publicações Instagram</h3>
            <p className="text-sm text-gray-500 mb-4">
              Faça upload das imagens das 3 publicações que aparecem no site e defina o link de cada uma.
            </p>
          </div>

          {/* Post 1 */}
          <div className="bg-white p-4 rounded-lg border border-gray-200 space-y-3">
            <h4 className="font-medium text-gray-700 flex items-center gap-2">
              <span className="bg-amber-100 text-amber-800 text-xs font-bold px-2 py-1 rounded">1</span>
              Publicação 1
            </h4>
            <ImageUpload
              currentImage={data.post_image1}
              onImageChange={(path) => setData({ ...data, post_image1: path })}
              label="Imagem da Publicação 1"
            />
            <div>
              <label className="block text-sm text-gray-600 mb-1">Link da publicação (URL)</label>
              <input
                type="url"
                value={data.post_url1}
                onChange={(e) => setData({ ...data, post_url1: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/p/..."
              />
            </div>
          </div>

          {/* Post 2 */}
          <div className="bg-white p-4 rounded-lg border border-gray-200 space-y-3">
            <h4 className="font-medium text-gray-700 flex items-center gap-2">
              <span className="bg-amber-100 text-amber-800 text-xs font-bold px-2 py-1 rounded">2</span>
              Publicação 2
            </h4>
            <ImageUpload
              currentImage={data.post_image2}
              onImageChange={(path) => setData({ ...data, post_image2: path })}
              label="Imagem da Publicação 2"
            />
            <div>
              <label className="block text-sm text-gray-600 mb-1">Link da publicação (URL)</label>
              <input
                type="url"
                value={data.post_url2}
                onChange={(e) => setData({ ...data, post_url2: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/p/..."
              />
            </div>
          </div>

          {/* Post 3 */}
          <div className="bg-white p-4 rounded-lg border border-gray-200 space-y-3">
            <h4 className="font-medium text-gray-700 flex items-center gap-2">
              <span className="bg-amber-100 text-amber-800 text-xs font-bold px-2 py-1 rounded">3</span>
              Publicação 3
            </h4>
            <ImageUpload
              currentImage={data.post_image3}
              onImageChange={(path) => setData({ ...data, post_image3: path })}
              label="Imagem da Publicação 3"
            />
            <div>
              <label className="block text-sm text-gray-600 mb-1">Link da publicação (URL)</label>
              <input
                type="url"
                value={data.post_url3}
                onChange={(e) => setData({ ...data, post_url3: e.target.value })}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                placeholder="https://www.instagram.com/p/..."
              />
            </div>
          </div>
        </div>
      </div>

      {message && (
        <div className={`p-4 rounded-lg ${message.includes('sucesso') ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={isSaving}
        className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 disabled:opacity-50"
      >
        {isSaving ? 'Salvando...' : 'Salvar Alterações'}
      </button>
    </div>
  );
}
